export const XdmRelationType = {
  Direct: 'Direct',
  Mapping: 'Mapping',
};
